import { getClientObj } from '../helpers';
import { getTranslations } from '../translations';

export const getInitialState = (clientCode, isPreview) => {
	const client = getClientObj(clientCode.toUpperCase() || 'AOL');
	const translations = getTranslations(clientCode.toUpperCase() || 'AOL');
	const isPopularSearchesEnabled = window?.AOSearchWidget?.popularSearchesEnabled || false;

	return {
		_t: translations,
		...client,
		clientCode,
		isPreview,
		settings: {
			minCharacters: 1,
			delay: 300
		},
		numberOfResults: 0,
		selectedResultText: '',
		rawUserInput: '',
		searchBarVariant: 'SiteHeader',
		selectedResultType: '',
		userInputText: '',
		showPopularSearches: false,
		isPopularSearchesEnabled,
		inputFocused: false
	};
};

export const reducer = (state, action) => {
	switch (action.type) {
		case 'setRawUserInput':
			return {
				...state,
				rawUserInput: action.rawUserInput
			};

		case 'setSelectedResult':
			return {
				...state,
				selectedResultText: action.selectedResultText,
				selectedResultType: action.selectedResultType
			};

		case 'showPopularSearches':
			return {
				...state,
				showPopularSearches: action.showPopularSearches
			};

		case 'isPopularSearchesEnabled':
			return {
				...state,
				isPopularSearchesEnabled: action.isPopularSearchesEnabled
			};

		case 'setInputFocused':
			return {
				...state,
				inputFocused: action.inputFocused
			};

		default:
			return state;
	}
};
